<script>
    export default {
        props: {
            filter: Object,
        },
        data() {
            return {
                productNr: '',
            }
        },
        mounted() {
            this.productNr = this.$root.filter.productNr;
        },
        watch: {
            productNr(value) {
                this.$root.filter.productNr = value;
            },
            filter(value) {
                if (value.reset) {
                    this.productNr = '';
                }
            }
        },
        methods: {
            search() {
                this.$root.startSearch();
            }
        }
    }
</script>

<template>
    <div>
        <h5 class="m-t-md m-b-xs">Produktnummer</h5>
        <div class="m-b">
            <input class="form-control" v-model="productNr" @keyup.enter="search">
        </div>
    </div>
</template>
